// Client-side mirror of backend PASSWORD_MIN_LEN + PASSWORD_POLICY_HINT.
// Keep both files in sync when tightening the policy.
export const PASSWORD_MIN_LEN = 10;

const RULES = [
  { key: "len",     label: `At least ${PASSWORD_MIN_LEN} characters`, test: (p) => (p || "").length >= PASSWORD_MIN_LEN },
  { key: "letter",  label: "A letter (A–Z / a–z)",  test: (p) => /[A-Za-z]/.test(p || "") },
  { key: "digit",   label: "A number (0–9)",        test: (p) => /\d/.test(p || "") },
  { key: "symbol",  label: "A symbol (e.g. ! @ #)", test: (p) => /[^A-Za-z0-9\s]/.test(p || "") },
];

export function checkPasswordRules(pw) {
  return RULES.map((r) => ({ ...r, ok: r.test(pw) }));
}

export function isPasswordValid(pw) {
  return checkPasswordRules(pw).every((r) => r.ok);
}
